import React from "react";
import {
  DataTable,
  DataTableCell,
  DataTableCellActions,
  DataTableHead,
  DataTableHeader,
  DataTableBody,
  DataTableRow,
  IconButton,
} from "@livingdesign/react";

export const QA_ID_PREFIX = "Datatable";

function Datatable({ headers, rows, emptyRowsMessage }) {
  return (
    <>
      <DataTable data-testid={QA_ID_PREFIX}>
        <DataTableHead data-testid={QA_ID_PREFIX + "-head"}>
          <DataTableRow data-testid={QA_ID_PREFIX + "-header-row"}>
            {headers?.map((header, idx) => {
              return (
                <DataTableHeader
                  key={QA_ID_PREFIX + "-header-" + header?.label}
                  data-testid={QA_ID_PREFIX + "-header-" + idx}
                >
                  {header?.label}
                </DataTableHeader>
              );
            })}
          </DataTableRow>
        </DataTableHead>
        <DataTableBody data-testid={QA_ID_PREFIX + "-body"}>
          {rows?.length === 0 && (
            <DataTableRow data-testid={QA_ID_PREFIX + "-empty-row"}>
              <DataTableCell data-testid={QA_ID_PREFIX + "-empty-cell"}>
                {emptyRowsMessage}
              </DataTableCell>
            </DataTableRow>
          )}
          {rows?.map((row, idx) => {
            return (
              <DataTableRow 
                key={QA_ID_PREFIX + "-row-" + idx}
                data-testid={QA_ID_PREFIX + "-row-" + idx}
              >
                {row?.map((cell, cellIdx) => {
                  return (
                    <DataTableCell 
                      key={QA_ID_PREFIX + "-cell-" + cellIdx}
                      data-testid={QA_ID_PREFIX + "-row-" + idx + "-cell-" + cellIdx}
                    >
                      {cell}
                    </DataTableCell>
                  );
                })}
              </DataTableRow>
            );
          })}
        </DataTableBody>
      </DataTable>
    </>
  );
}

export default Datatable;
